import { X } from '../../icons/X';
import { cn } from '../../utils';
import { FormTagVariant } from './FormTagField.utils';

export interface TagProps {
  value: string;
  variant?: FormTagVariant;
  onRemove?: () => void;
}

const tagVariants: Record<FormTagVariant, string> = {
  default: 'bg-info-soft text-primary',
  warning: 'bg-warning-soft text-warning-foreground',
  error: 'bg-accent-pink-soft text-accent-pink',
};

export const FormTag = ({ value, onRemove, variant = 'default' }: TagProps) => (
  <span
    className={cn(
      'leading[18px] flex items-center gap-1.5 rounded-sm py-0.5 pr-1.5 pl-2.5 text-sm',
      tagVariants[variant]
    )}
  >
    {value}
    <button onClick={onRemove}>
      <X className="size-3 cursor-pointer" />
    </button>
  </span>
);
